import { provideZoneChangeDetection } from "@angular/core";
import {platformBrowserDynamic} from '@angular/platform-browser-dynamic';

import {AppModule} from './app/ui/app.module';

platformBrowserDynamic().bootstrapModule(AppModule, { applicationProviders: [provideZoneChangeDetection()], })
    .catch(err => console.error(err));